export const BEFORE_SESSION_LOGOUT_EVENT = 'nucleai:before-session-logout';

export type LocalWorkBackupHandler = () => void | Promise<void>;

const localWorkHandlers = new Set<LocalWorkBackupHandler>();

export const registerLocalWorkHandler = (handler: LocalWorkBackupHandler): (() => void) => {
  localWorkHandlers.add(handler);
  return () => {
    localWorkHandlers.delete(handler);
  };
};

export const unregisterLocalWorkHandler = (handler: LocalWorkBackupHandler): void => {
  localWorkHandlers.delete(handler);
};

/**
 * Runs every registered local-work backup handler and fails if any handler
 * fails. Completes as a successful no-op when nothing is registered.
 */
export const awaitLocalWorkBackup = async (): Promise<void> => {
  const handlers = [...localWorkHandlers];
  if (handlers.length === 0) {
    return;
  }

  const results = await Promise.allSettled(handlers.map((handler) => Promise.resolve().then(handler)));
  const firstFailure = results.find((result) => result.status === 'rejected');
  if (firstFailure) {
    throw firstFailure.reason;
  }
};

/**
 * Compatibility shim for remaining event listeners. Production session-exit
 * paths must await `awaitLocalWorkBackup()` instead of this fire-and-forget API.
 */
export const flushLocalWorkBeforeSessionLogout = () => {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(BEFORE_SESSION_LOGOUT_EVENT));
  }
};
